<template>
  <div class="access-publisher">
    <el-dialog
      :visible="subscribePublisherPopupVisible"
      class="access-publisher-dialog"
      v-if="!userProfile.mark_as_verified_user"
      :before-close="handleClose"
    >
      <div class="flex-space-between">
        <div class="flex">
          <div class="image-container">
            <img
              src="../assets/images/Publish Icon (1).svg"
              style="width: 20px;padding-left: 5px"
            />
          </div>
          <div
            class="label-md-bold-black left-margin-10"
            style="color: #2d2e8d; background-color:#DBEBFF; font-size:20px "
          >
            <span style="color:#000000;font-size:20px">Subscribe StockAnts</span
            >Publisher
          </div>
        </div>
      </div>

      <div class="sub-section">
        <div class="contents">
          <p class="flex">
            <span class="feature-number">1 </span>Publish Unlimited
            Recommendations & Strategies
          </p>

          <p class="flex">
            <span class="feature-number">2 </span>Build Your Track Record
          </p>

          <p class="flex">
            <span class="feature-number">3 </span>Certification of your
            expertise & Enhance your Resume
          </p>
        </div>

        <div class="price">
          <p>
            <span class="price-amount">₹ 999</span>
            <span class="days"> /30 Days</span>
          </p>
        </div>

        <el-button
          class="btn-secondary-theme-filled subscribe-btn"
          @click="goToPlansPage()"
          type="primary"
          >Subscribe Now</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      subscribePublisherPopupVisible: false,
      mark_as_verified_user: "",
      userProfile: {},
    };
  },
  mounted() {
    //returns stored user profile from local storage
    if (localStorage.getItem("profile")) {
      this.userProfile = JSON.parse(localStorage.getItem("profile"));
    }

    if (localStorage.getItem("publisher_plan_details")) {
      var publisherPlaData = JSON.parse(
        localStorage.getItem("publisher_plan_details")
      );

      if (publisherPlaData.plan == "Publisher") {
        this.subscribePublisherPopupVisible = false;
      } else {
        this.subscribePublisherPopupVisible = true;
      }
    } else {
      this.subscribePublisherPopupVisible = true;
    }
  },
  methods: {
    goToPlansPage() {
      {
        // localStorage.setItem("premiumPlanSubscriptionDialogVisible", true);

        this.$router.push({ path: "/pricing?method=subscribe_publisher" });
        return;
      }
    },
    goToLink(link) {
      if (link) {
        this.$router.push(link);
      }
    },

    handleClose() {
      if (this.$route.path == "/publish-recommendation-options") {
        this.goToLink("/expert-past-strategy-options");
      } else {
        this.goToLink("/data-categorisation");
      }
    },
  },

  computed: {
    getSubscribedPlanDetails() {
      return JSON.parse(localStorage.getItem("plan_details"));
    },
  },
};
</script>

<style lang="scss" scoped>
.access-publisher {
  .flex-space-between {
    color: #2d2e8d;
    background-color: #dbebff;
    padding: 20px;
    margin-left: -20px;
    margin-right: -20px;
    margin-top: -30px;
    border-radius: 10px 10px 0px 0px;
  }

  .subscribe-btn {
    width: 100%;
    padding: 10px 30px;
    border-radius: 50px;
    font-size: 15px;
    font-weight: 600px;
  }

  .contents {
    font-family: Arial, sans-serif;
    color: #333;
  }

  .contents p {
    width: 320px;
    margin-bottom: 15px;
    margin-left: 10px;
    margin-top: 20px;
    font-size: 14px;
    color: black;
    text-align: left !important;
  }

  .contents strong {
    font-weight: bold;
  }

  .price {
    margin-top: 20px;
    text-align: center;
    margin-bottom: 20px;
  }

  .price p {
    margin: 0;
  }

  .price-amount {
    font-size: 25px;
    font-weight: 700;
    color: black;
  }

  .days {
    font-size: 14px;
    color: black;
    font-weight: bold;
  }

  .flex span {
    font-size: 15px;
    font-weight: 500px;
    margin-right: 12px;
  }

  .image-container {
    display: flex;
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background-color: #2d2e8d;
  }

  .image-container img {
    width: 30px;
    height: auto;
    padding: 5px;
  }

  .feature-number {
    background-color: #d2e5fc;
    padding: 3px 6px;
    border-radius: 50%;
    font-size: 12px;
    font-weight: 700px;
    margin-right: 10px;
    color: #2d2e8d;
  }
}
</style>

<style lang="scss">
.access-publisher-dialog {
  .el-dialog {
    width: 460px;
    box-shadow: none;
    border-radius: 10px;
    background-color: #f5faff;
  }
  .el-dialog__body {
    word-break: break-word;
    //   padding: 20;
  }

  .el-dialog__header {
    padding: 0;
  }
}

@media screen and (max-width: 400px) {
  .access-publisher-dialog .el-dialog {
    width: 310px;
    width: 95%;
    margin: 0 auto;
  }
}
</style>
